function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg129Cuba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "0.001,44.521 0,44.521 0,467.477 0.001,467.477 0.001,256 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.008,
    style: {
      fill: "#F0F0F0"
    },
    width: 511.999,
    height: 511.988
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.008,
    style: {
      fill: "#0052B4"
    },
    width: 511.999,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.799,
    style: {
      fill: "#0052B4"
    },
    width: 511.999,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.599,
    style: {
      fill: "#0052B4"
    },
    width: 511.999,
    height: 102.4
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "256.001,256.008 0.001,511.998 0.001,0.001 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "83.478,195.132 98.585,241.628 147.479,241.628 107.925,270.368 123.032,316.867   83.478,288.129 43.923,316.867 59.033,270.368 19.479,241.628 68.371,241.628 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg129Cuba);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMS45OTkgNTExLjk5OSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTExLjk5OSA1MTEuOTk5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRjk4MTE7IiBwb2ludHM9IjAuMDAxLDQ0LjUyMSAwLDQ0LjUyMSAwLDQ2Ny40NzcgMC4wMDEsNDY3LjQ3NyAwLjAwMSwyNTYgIi8+CjxyZWN0IHg9IjAiIHk9IjAuMDA4IiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgd2lkdGg9IjUxMS45OTkiIGhlaWdodD0iNTExLjk4OCIvPgo8Zz4KCTxyZWN0IHg9IjAiIHk9IjAuMDA4IiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgd2lkdGg9IjUxMS45OTkiIGhlaWdodD0iMTAyLjQiLz4KCTxyZWN0IHg9IjAiIHk9IjIwNC43OTkiIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiB3aWR0aD0iNTExLjk5OSIgaGVpZ2h0PSIxMDIuNCIvPgoJPHJlY3QgeD0iMCIgeT0iNDA5LjU5OSIgc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHdpZHRoPSI1MTEuOTk5IiBoZWlnaHQ9IjEwMi40Ii8+CjwvZz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHBvaW50cz0iMjU2LjAwMSwyNTYuMDA4IDAuMDAxLDUxMS45OTggMC4wMDEsMC4wMDEgIi8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBwb2ludHM9IjgzLjQ3OCwxOTUuMTMyIDk4LjU4NSwyNDEuNjI4IDE0Ny40NzksMjQxLjYyOCAxMDcuOTI1LDI3MC4zNjggMTIzLjAzMiwzMTYuODY3ICAgODMuNDc4LDI4OC4xMjkgNDMuOTIzLDMxNi44NjcgNTkuMDMzLDI3MC4zNjggMTkuNDc5LDI0MS42MjggNjguMzcxLDI0MS42MjggIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };